import React from "react";

const Loading = () => {
  return (
    <div className="flex items-center justify-center w-full py-16">
      <div className="flex flex-col items-center">
        {/* Spinner */}
        <div className="relative" style={{ width: 48, height: 48 }}>
          <div
            className="absolute inset-0 rounded-full"
            style={{
              background: "radial-gradient(circle, rgba(91,100,143,0.06) 0%, transparent 70%)",
              transform: "scale(2)",
            }}
          />
          <svg
            viewBox="0 0 48 48"
            fill="none"
            className="absolute inset-0"
            style={{ width: 48, height: 48, animation: "ldRotate 1.4s cubic-bezier(0.4, 0, 0.2, 1) infinite" }}
          >
            <circle cx="24" cy="24" r="19" stroke="rgba(91,100,143,0.08)" strokeWidth="2.5" fill="none" />
            <path
              d="M24 5a19 19 0 0 1 19 19"
              stroke="url(#ldGrad)"
              strokeWidth="2.5"
              strokeLinecap="round"
              fill="none"
            />
            <defs>
              <linearGradient id="ldGrad" x1="24" y1="5" x2="43" y2="24">
                <stop offset="0%" stopColor="#5b648f" stopOpacity="0.2" />
                <stop offset="100%" stopColor="#5b648f" stopOpacity="1" />
              </linearGradient>
            </defs>
          </svg>
          <div
            className="absolute rounded-full"
            style={{
              width: 6,
              height: 6,
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#5b648f",
              animation: "ldPulse 1.4s ease-in-out infinite",
            }}
          />
        </div>

        {/* Dots */}
        <div className="flex items-center gap-[5px] mt-5">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="rounded-full"
              style={{
                width: 4,
                height: 4,
                backgroundColor: "#5b648f",
                animation: `ldDot 1.2s ease-in-out ${i * 0.15}s infinite`,
              }}
            />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes ldRotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes ldPulse {
          0%, 100% { opacity: 0.3; transform: translate(-50%, -50%) scale(0.8); }
          50% { opacity: 1; transform: translate(-50%, -50%) scale(1.2); }
        }
        @keyframes ldDot {
          0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }
          40% { opacity: 1; transform: scale(1.3); }
        }
      `}</style>
    </div>
  );
};

export default Loading;
